import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M112 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16m304 192H312v72h104zm0 104H312v80h104zm0 112H312v72h72c17.7 0 32-14.3 32-32zm-136-32v-80H168v80zm-112 32v72h112v-72zm-32-32v-80H32v80zM32 408v40c0 17.7 14.3 32 32 32h72v-72zm0-144h104v-72H32zm136 0h112v-72H168zM384 96H64c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32"
    }, null, -1)
  ])))
}
export default { render: render }